import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { toast } from "sonner";

export const SettingsPanel = () => {
  const { settings, refresh } = useSettings();
  const [form, setForm] = useState(settings);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setForm(settings); }, [settings]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings", form);
      await refresh();
      toast.success("Ajustes guardados");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4 max-w-lg">
      <Field label="Nombre de la tienda"><input value={form.store_name || ""} onChange={set("store_name")} className="inp" /></Field>
      <Field label="Eslogan"><input value={form.tagline || ""} onChange={set("tagline")} className="inp" /></Field>
      <Field label="Número de WhatsApp (con código de país, sin +)">
        <input data-testid="settings-whatsapp" value={form.whatsapp_number || ""} onChange={set("whatsapp_number")} className="inp" placeholder="521234567890" />
      </Field>
      <Field label="Símbolo de moneda"><input value={form.currency || ""} onChange={set("currency")} className="inp w-24" /></Field>
      <Field label="Instagram (URL)"><input value={form.instagram_url || ""} onChange={set("instagram_url")} className="inp" placeholder="https://instagram.com/..." /></Field>
      <Field label="Facebook (URL)"><input value={form.facebook_url || ""} onChange={set("facebook_url")} className="inp" placeholder="https://facebook.com/..." /></Field>
      <Field label="Título del hero"><input value={form.hero_title || ""} onChange={set("hero_title")} className="inp" /></Field>
      <Field label="Subtítulo del hero"><textarea rows={2} value={form.hero_subtitle || ""} onChange={set("hero_subtitle")} className="inp resize-none" /></Field>

      <div className="pt-2 border-t border-[#E3E7E2]">
        <p className="text-sm font-bold text-charcoal mb-1">Publicidad y analítica (Google & Meta Ads)</p>
        <p className="text-xs text-muted-moss mb-3">Pega tus identificadores cuando los tengas. La tienda disparará los eventos clave (vista de producto, agregar al carrito, checkout) automáticamente.</p>
        <div className="space-y-4">
          <Field label="Google Analytics 4 (Measurement ID)"><input data-testid="settings-ga4" value={form.ga4_id || ""} onChange={set("ga4_id")} className="inp" placeholder="G-XXXXXXXXXX" /></Field>
          <Field label="Google Ads (Conversion ID)"><input data-testid="settings-google-ads" value={form.google_ads_id || ""} onChange={set("google_ads_id")} className="inp" placeholder="AW-XXXXXXXXXX" /></Field>
          <Field label="Meta Pixel ID"><input data-testid="settings-meta-pixel" value={form.meta_pixel_id || ""} onChange={set("meta_pixel_id")} className="inp" placeholder="1234567890" /></Field>
        </div>
      </div>

      <button data-testid="settings-save" onClick={save} disabled={saving} className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-coral text-white font-bold hover:bg-coral-dark active:scale-95 transition-all disabled:opacity-60">
        {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />} Guardar ajustes
      </button>
    </div>
  );
};

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-xs font-semibold uppercase tracking-wide text-muted-moss">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);
